<template>
    <div>

        <dashboard>
        </dashboard>

        <v-card
          class="mx-4"
          max-width="500">
            
            <v-card-title>
                Weekly API Call Count
            </v-card-title>

            <v-simple-table>
              <thead>
                <tr>
                  <th>Marketplace</th>
                  <th>Date</th>
                  <th>API</th>
                  <th class="text-right">Calls</th>
                </tr>
              </thead>
              <tbody>
                <tr v-for="item in apiCalls" :key="item.marketplaceName + item.date + item.apiName">
                  <td>{{ item.marketplaceName          }}</td>
                  <td>{{ item.date | toDateOnly()      }}</td>
                  <td>{{ item.apiName                  }}</td>
                  <td class="text-right">{{ item.count }}</td>
                </tr>
              </tbody>
            </v-simple-table>

        </v-card>
    </div>
</template>

<style lang="css" scoped>
    .row-pointer >>> tbody tr :hover {
        cursor: pointer;
    }
</style>

<script>
  import {SystemStatsService} from '../services/api/systemStats';
  const apiSystemStats = new SystemStatsService();

  export default {
      components: {
        Dashboard: () => import("../components/dashboard/dashboard")
      },

    data () {
        return {
            dashboard: null,
            apiCalls: [],
        }
    },

      created () {
        this.getAPICalls();
      },

    methods: {

      getDashboard() {
        apiSystemStats.getDashboard().then((data) => {
            //console.log("data: " + data);
            this.dashboard = data;
        });
      },
        
      getAPICalls() {
        apiSystemStats.getAPICalls().then((data) => {
            //console.log("data: " + data);
            this.apiCalls = data;
        });
      },
    }
}
</script>
